// @flow
import React, { useState, useEffect, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { isiOSSafari as checkiOSSafari } from 'shared/lib/useragentdetection';

type Props = {
  show: boolean,
  url: ?string,
  onClose: () => void
}

// Full screen video overlay for carousel
const VideoOverlay = (props: Props) => {
  const {
    show,
    onClose,
    url
  } = props;

  const c: { [key: string]: string } = useStyles();

  // Use native fullscreen controls in iOS
  const [isiOSSafari] = useState(checkiOSSafari());

  const videoRef = useRef();

  // iOS detect fullscreen close on iOS
  useEffect(() => {
    if (!isiOSSafari) {
      return;
    }

    const video = videoRef.current;
    const hideVideo = () => {
      onClose();
    };

    video?.addEventListener('webkitendfullscreen', hideVideo);

    return () => {
      video?.removeEventListener('webkitendfullscreen', hideVideo);
    };
  }, [isiOSSafari, videoRef, onClose]);

  if (!show) {
    return null;
  }

  if (isiOSSafari) {
    return (
      <video
        ref={videoRef}
        controls
        autoPlay
        className={cx(c.video, c.videoiOS)}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }}
        disablePictureInPicture
        controlsList="nodownload noremoteplayback"
      >
        <source src={url} type="video/mp4" />
      </video>
    );
  }

  // Modal for non-iOS platforms
  return (
    <div className={c.modal} onClick={onClose}>
      <i
        className={cx(c.closeBtn, 'material-icons')}
        onClick={onClose}
      >close
      </i>
      {
        url &&
        <video
          controls
          playsInline
          autoPlay
          className={c.video}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }}
          disablePictureInPicture
          controlsList="nodownload noremoteplayback"
        >
          <source src={url} type="video/mp4" />
        </video>
      }
    </div>
  );
};

const useStyles = createUseStyles({
  modal: {
    position: 'fixed',
    backgroundColor: 'black',
    left: '0',
    right: '0',
    top: '0',
    bottom: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '55'
  },
  closeBtn: {
    position: 'absolute',
    right: '10px',
    top: '10px',
    fontSize: '20px',
    cursor: 'pointer',
    color: 'white',
    // iOS notch
    '@media only screen and (max-width:960px)': {
      top: 'max(env(safe-area-inset-top, 44px), 44px)',
    }
  },
  video: {
    width: '90%'
  },
  videoiOS: {
    position: 'absolute',
  },
});

export default VideoOverlay;
